/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  ConfigurationHelper,
  IAppState,
  IScreenModel,
  RouteHelper,
} from "@xala/common";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { match as RouterMatch } from "react-router";

import { AppFooter, AppHeader } from "../../components";
import { BaseScreen } from "../BaseScreen";

import "./MainScreen.scss";

interface IMainScreenProps {
  match: RouterMatch<{ id?: string }>;
}

export const MainScreen = ({ match }: IMainScreenProps) => {
  const [screenKey, setScreenKey] = useState(
    RouteHelper.getScreenRouteKey(match)
  );
  const configuration = useSelector(
    (state: IAppState) => state.configuration.configuration
  );

  useEffect(() => {
    const newScreenKey = RouteHelper.getScreenRouteKey(match);

    if (screenKey !== newScreenKey) {
      setScreenKey(newScreenKey);
    }
  }, [screenKey, match]);

  useEffect(() => {
    const script = document.getElementById(
      "script_of_FSWebChat"
    ) as HTMLScriptElement | null;

    if (screenKey === "contacte") {
      if (!script) {
        (function (d, s) {
          const fs: any = ((window as any).FSWebChat = function () {});
          fs._s = d.createElement(s);
          fs._h = d.getElementsByTagName(s)[0];
          fs._domain = "2cb42dff-609e-47c4-9223-55ebd44ec118";
          fs._hashkey = "c2e5a0d602a8486257ab6f799f308e4ca3f8e9ec";
          fs._subfolder = "/contacte";
          fs._server = "https://es-i1-cloud01.gocontact.com:443/poll";
          fs._service = "/new-webchat-service";
          fs._timestamp = +new Date();
          fs._s.setAttribute("charset", "utf-8");
          fs._s.src =
            fs._server +
            fs._service +
            "/startup/" +
            fs._domain +
            "/" +
            fs._hashkey;
          fs._s.type = "text/javascript";
          fs._s.async = true;
          fs._s.id = "script_of_FSWebChat";
          fs._h.parentNode.insertBefore(fs._s, fs._h);
        })(document, "script");
      }
    }

    return () => {
      if (
        !location.pathname.includes("profile") &&
        !location.pathname.includes("contacte")
      ) {
        const script = document.getElementById(
          "script_of_FSWebChat"
        ) as HTMLScriptElement | null;
        const chatContainer = document.getElementById("fs_webchat_container");

        script && document.head.removeChild(script);
        chatContainer && document.body.removeChild(chatContainer);
      }
    };
  }, [screenKey]);

  if (!configuration || !configuration.Screens) {
    return null;
  }

  let screen: IScreenModel | undefined = undefined;

  if (screenKey) {
    screen = ConfigurationHelper.getScreenByRouteKey(configuration, screenKey);
  }

  if (!screen || screen.ScreenTypeCode === undefined) {
    return null;
  }

  return (
    <BaseScreen>
      {({ renderScreen }) => (
        <div className="MainScreen">
          <AppHeader configuration={configuration} />
          <section>{renderScreen(screen)}</section>
          <AppFooter />
        </div>
      )}
    </BaseScreen>
  );
};
